import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@api/client';
import { queryKeys } from '@api/queryKeys';
import type { DeviceRegistration, DeviceRegistrationResponse } from '@shared/types/device';

export function useDeviceRegistration(options?: { onSuccess?: () => void }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: DeviceRegistration) =>
      apiClient.post<DeviceRegistrationResponse>('/device/register', data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.health });
      options?.onSuccess?.();
    },
  });
}
